import Skeleton from '../../../common/skeleton';
import { Row, Col, Card } from 'react-bootstrap';
export default () => (
  <Row className="mt-2">
    <Col sm={12}>
      <Card className="p-3">
        <Skeleton count={2} height={30} />
        <Skeleton count={1} height={100} />
      </Card>
    </Col>
  </Row>
);
